import token from "./token";
import recording from "./recording";
import file from "./file";

export default { ...token, ...recording, ...file };
